export const initChuckClient = ({ formatUrl, captureException, Storage, storeTokenLocally }) => {
    return {
        formatUrl,
        captureException,
        Storage,
        storeTokenLocally
    };
};
//# sourceMappingURL=client.js.map